import React from 'react'
import AchievementSection from './AchievementSection'

const SuccessStoriesSection = () => {

    return (
        <div className=''>
            <AchievementSection/>
        </div>
    )
}

export default SuccessStoriesSection